var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9298",
    style: {
      fill: "none"
    },
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10167"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38584",
    d: "M71.016 15.223V1.232a1.121 1.121 0 0 1 2.227-.248c.012.13.01.262.01.394V15.155l.116.089a.974.974 0 0 1 .133-.254q2.257-2.262 4.52-4.518a1.115 1.115 0 0 1 1.154-.322 1.055 1.055 0 0 1 .775.816 1.092 1.092 0 0 1-.326 1.078q-.827.828-1.656 1.654l-4.915 4.9a1.148 1.148 0 0 1-1.829.008L64.69 12.1a1.142 1.142 0 0 1-.377-1.113 1.119 1.119 0 0 1 1.845-.585c.235.21.45.442.674.665l3.928 3.919c.067.066.136.13.255.243",
    transform: "translate(-57.133 2.665)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38585",
    d: "M2.252 245.09h20.223v-4.478a1.118 1.118 0 0 1 2.169-.38 1.537 1.537 0 0 1 .077.488q.008 2.693 0 5.386a1.141 1.141 0 0 1-1.25 1.238H1.25A1.14 1.14 0 0 1 0 246.1v-5.412a1.113 1.113 0 0 1 .666-1.1 1.064 1.064 0 0 1 1.183.163 1.128 1.128 0 0 1 .4.929v4.406",
    transform: "translate(2.637 -220.007)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.145201f748493c602a73121f77b82f6f.svg";
export { ForwardRef as ReactComponent };